import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <a href="/" className="font-heading text-xl font-bold tracking-tight whitespace-nowrap">
              CSSSpreadsheet<span className="text-primary-400">.pics</span>
            </a>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              The largest free spreadsheet directory for CSSBuy, Kakobuy, Superbuy, and Oopbuy. Updated daily with verified links and trusted seller recommendations.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-3">Categories</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-3">Resources</h4>
            <ul className="space-y-2">
              <li><a href="/article/best-cssbuy-spreadsheet-guide" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">CSSBuy Guide</a></li>
              <li><a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">FAQ</a></li>
              <li><a href="#guides" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">Buying Guides</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">CSSBuy Sheet</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-3">Shop Smarter</h4>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">With verified spreadsheets, trusted sellers, and daily updates — buying through agents has never been easier.</p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-400 whitespace-nowrap">
            &copy; {new Date().getFullYear()} CSSSpreadsheet.pics. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">Privacy</a>
            <a href="/" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">Terms</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">CSSBuy Sheet</a>
          </div>
        </div>
      </div>
    </footer>
  );
}